// ES_TRO_Today_You_Are_Going_To_Read
export const demoVideoStart =
    'Vas a leer 2 cuentos en voz alta y responder preguntas acerca de ellos. Veamos un video sobre los cuentos y las preguntas antes de comenzar.';

// ES_TRO_Reminder Page_Backup
export const bookStartGeneral =
    'Ahora vas a leerme un libro en voz alta. Luego, vas a responder unas preguntas. Lee todas las palabras en el área blanca. No leas ninguna palabra en el área oscura. Podrás ver las palabras en el área oscura después de detener la grabación. Haz clic en la flecha verde para comenzar a leer el primer libro.'; // not used

// ES_TRO_Mic_Access
export const trcMicPermission =
    'Antes de empezar a leer, necesitamos prender el micrófono. Haz clic en el botón verde. Luego, haz clic en el botón que dice “Allow” que aparece en la pantalla. ';

// ES_TRO_Test_Mic
export const trcMicTesting =
    'Ahora necesitamos asegurarnos de que pueda escucharte. Haz clic en el botón “Start recording” (“Comenzar la grabación”) y luego di: “Al perro le gusta jugar con la pelota.” Cuando termines de hablar, haz clic en “Stop recording” (“Detener la grabación”).';

// ES_TRO_Test_Mic_Try_Again
export const trcMicTestRetry =
    'Intentemos otra vez. Acércate a tu dispositivo y habla lo más alto y claro que puedas. Haz clic para comenzar la grabación y di: “Al perro le gusta jugar con la pelota”. Cuando termines de hablar, haz clic en “Stop recording” (“Detener la grabación”).';

// ES_TRO_Test_Mic_Pass
export const trcMicTestSuccess = 'Haz clic en la flecha verde para continuar.';

// ES_TRO_Remember_Read_Outloud
export const trcCountdownReminder =
    'Recuerda leer en voz alta, lo más alto y claro que puedas. (cuenta regresiva)';

// ES_TRO_Instructions_For_Questions
export const comprehensionReady =
    'Responde la pregunta y haz clic en "OK". Usa el texto si necesitas ayuda para responder la pregunta.';

// ES_TRO_Read_Answer_Questions
export const comprehensionReplay =
    'El texto que leíste está a la izquierda. Lee y responde las preguntas. Usa el texto si necesitas ayuda para responder las preguntas.';

// ES_TRO_Test_Mic_Not_Reading_Loud_Enough
export const trcMicVerificationFailure =
    'Tenemos que chequear un par de cosas más antes de empezar a leer. Levanta la mano si necesitas ayuda.';

// ES_TRO_Practice_Reading
export const troMicReadingCheck =
    'Ahora, vamos a practicar la lectura. Haz clic en “start recording” (“Comenzar la grabación”) y lee en voz alta la oración en la pantalla. Cuando termines de leer, haz clic en “Stop recording.” (“Detener la grabación”)';

// ES_TRO_Continue_Reading
export const troMultiChoiceReadingCheckInstructions =
    'Continuemos leyendo. Haz clic en el ícono de audio y escucha la oración. Luego, haz clic en el botón que muestra la oración que escuchaste.';

// ES_TRO_Test_Mic_Not_Reading_Loud_Enough_Again
export const thatDidntWorkTwo = 'Lo siento, eso no funcionó.';

// ES_TRO_Done_Answering
export const comprehensionCompleteReminder = '¿Ya terminaste de responder todas las preguntas?';

// ES_TRO_Done_Reading
export const bookCompleteReminder = '¿Ya terminaste de leer?';

// ES_TRO_Make_Sure
export const fluencyReminder = 'Asegúrate de que estés leyendo.';

// ES_TRO_Red_Bike
export const troMultiChoiceReadingCheckSentence = 'Tengo una bicicleta roja.';

// ES_TRO_Reminder Page_Backup
export const trcReminders =
    'Ahora vas a leerme un libro en voz alta. Luego, vas a responder unas preguntas. Lee todas las palabras en el área blanca. No leas ninguna palabra en el área oscura. Podrás ver las palabras en el área oscura después de detener la grabación. Haz clic en la flecha verde para comenzar a leer el primer libro.';
